import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';
import IOSSwitch from '../../IOSSwitch/IOSSwitch';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { updateActivityRequest } from '../../../redux/activity/activitySlice';
import createPermissionCheckers from '../../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../../types/commonTypes';

interface IActiveSwitchProps {
  isActive: boolean | undefined;
  rowId: string | undefined;
}

// for now change the name of the activity , it should be isActive
const ActiveSwitch = ({ isActive, rowId }: IActiveSwitchProps) => {
  const dispatch = useAppDispatch();
  const selectedClient = useAppSelector((state) => state.client.selectedClient);
  const clientId = selectedClient?.id || '';
  const coach = useAppSelector((state) => state.coach.coach);
  const coachId = coach?.id || '';
  const { t } = useTranslation();

  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  const toggleIsActiveStatus = (status: boolean, activityId: string) => {
    if (!clientId) return;
    const data = {
      id: activityId,
      clientId,
      coachId,
      isActive: status,
    };
    dispatch(updateActivityRequest({ data, statusUpdate: true }));
  };

  if (!rowId) return null;

  return (
    <FormControlLabel
      control={
        <IOSSwitch isActive={isActive || false} toggleButton={toggleIsActiveStatus} rowId={rowId} />
      }
      label={isActive ? t('common.active') : t('common.deactive')}
      sx={{
        gap: '10px',
        '&.Mui-disabled .MuiTypography-root': {
          color: 'inherit',
        },
      }}
      disabled={!checkPermissions(UserPermissionType.ACTIVITY_MODULE_CHANGE_ACTIVITY_STATUS)}
    />
  );
};

export default ActiveSwitch;
